import React  from "react"
import ReactDOM from 'react-dom'

import './Assets/css/style.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from "react-redux"
import store from "./Store/index"

import AxiosInterceptor from "./Config/AxiosInterceptor"
AxiosInterceptor()

ReactDOM.render(
  <Provider store={store}>
    {/*<React.StrictMode>*/}{/* Text editor logging errors in strict mode */}
      <App />
    {/*</React.StrictMode>*/}
  </Provider>,
  document.getElementById('root')
)

reportWebVitals()
